/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tools_Section_TitleInputs */

const en_directory_tools_section_title = /** @type {(inputs: Directory_Tools_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a task`)
};

const zh_directory_tools_section_title = /** @type {(inputs: Directory_Tools_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一项任务`)
};

/**
* | output |
* | --- |
* | "Choose a task" |
*
* @param {Directory_Tools_Section_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tools_section_title = /** @type {((inputs?: Directory_Tools_Section_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tools_Section_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tools_section_title(inputs)
	return zh_directory_tools_section_title(inputs)
});
export { directory_tools_section_title as "directory.tools.section_title" }